// @flow
import React, { Component } from 'react';
import _ from 'lodash';
import { Segment, Header, Icon, Grid } from 'semantic-grab-ui/src';
import { GroupCommsMetrics } from 'types/trident-campaigns';
import MetricsCell from './MetricsCell';

type Props = {
  metrics: Array<GroupCommsMetrics>,
};

// MetricsPanel is the component for displaying the performance metrics for one scenario/schedule
export default class MetricsPanel extends Component {
  props: Props;

  render() {
    const { metrics } = this.props;
    // form rows, each with two columns
    const rows = [];
    for (let i = 0; i < metrics.length; i += 2) {
      const row = (i + 1) < metrics.length ? [metrics[i], metrics[i + 1]] : [metrics[i]];
      rows.push(row);
    }

    return (
      <div>
        {
          _.isEmpty(metrics) ?
            <Segment placeholder>
              <Header icon>
                <Icon name="pdf file outline" />
              No metrics available for {this.props.nodeName}
              </Header>
            </Segment>
            :
            <Grid celled="internally">
              {
                _.map(rows, (row, index) => {
                  return (<Grid.Row style={{ paddingTop: index > 0 ? 18 : 14 }}>
                    <Grid.Column width={8} style={{ paddingLeft: 0 }}>
                      <MetricsCell metrics={row[0]} />
                    </Grid.Column>
                    <Grid.Column width={8} style={{ paddingLeft: 32 }}>
                      {
                        row.length > 1 && <MetricsCell metrics={row[1]} />
                      }
                    </Grid.Column>
                  </Grid.Row>);
                })
              }
            </Grid>
        }
      </div>
    );
  }
}
